import { SelectInput } from '@framework/form';
import React from 'react';
import { IWidgetComponentProps } from '../../../../IWidgetType';
import { useSelectOptions } from '../../common/option-list/hooks/useSelectOptions';
import { getWidgetProps } from '../../common/util/getWidgetProps';
import { ISingleSelectWidget } from '../ISingleSelectWidget';
import { IUseSingleSelectWidgetOptionsReturn } from '../hooks/useSingleSelectWidgetOptions';

export interface ISingleSelectSelectComponentProps
  extends IWidgetComponentProps<ISingleSelectWidget>,
    IUseSingleSelectWidgetOptionsReturn {}

/**
 * Componente principale del widget select in caso di scelta di menù a tendina.
 */
export function SingleSelectSelectComponent(
  props: ISingleSelectSelectComponentProps,
) {
  const { options, componentOptions } = props;

  const widgetOptions = getWidgetProps(props);

  // const { enabledOptionsMap, visibleOptionsMap } =
  //   useDeselectInvalidOptionEffect(widgetOptions, options);

  const selectOptions = useSelectOptions(componentOptions, widgetOptions);

  return (
    <SelectInput
      readOnly={props.readonly}
      name={widgetOptions.name}
      options={selectOptions}
      group={componentOptions.type === 'grouped'}
      optionFilterProp="labelText"
      allowClear
      placeholder={
        widgetOptions.placeholder
          ? widgetOptions.placeholder
          : widgetOptions.preview
          ? 'Placeholder'
          : ''
      }
      // per accessibilità limitiamo virtual a 20 opzioni
      showSearch={true}
      virtual={selectOptions.length > 20}
    />
  );
}
